export const WAIT_BEFORE_ENROLLING = 500;
